<div mat-dialog-title="">
  <div class="flex justify-between items-center flex-row flex-wrap gap-[1rem]">
    <h3 class="mat-h2 m0" translate="">Document details</h3>
  </div>
</div>
<form [formGroup]="documentFormGroup">
  <mat-dialog-content class="flex flex-col">
    @if (classification?.classification?.documentTypeId) {
      <div class="classification-hint">
        <mat-icon>auto_awesome</mat-icon>
        <div>
          @if (!isSuggestion) {
            <span translate="">Recognised automatically, please check the values</span>
          } @else {
            <span translate="">Suggested automatically, please check the values before saving</span>
          }
          ({{classification.classification.confidence | percent}})
          @if (classification.classification.reasoning) {
            <div class="small gray">{{classification.classification.reasoning}}</div>
          }
        </div>
      </div>
    }
    <div class="flex flex-col w-full">
      <mat-form-field appearance="outline">
        <mat-label translate="">Document type</mat-label>
        <input formControlName="documentType" type="text" [placeholder]="'All document types' | translate" matInput="" [matAutocomplete]="documentTypeAutoComplete" required="" autocomplete="off">
        <mat-autocomplete autoActiveFirstOption="" #documentTypeAutoComplete="matAutocomplete" [displayWith]="displayDocumentType">
          @for (documentType of documentTypesFiltered | async; track documentType) {
            <mat-option [value]="documentType">
              <span class="small gray">{{documentType.id}}.</span>&nbsp;{{documentType.name}}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      @if (showCustomerInput) {
        <mat-form-field appearance="outline">
          <mat-label translate="">Link to client</mat-label>
          <mat-select formControlName="customer">
            @for (customer of customers; track customer) {
              @if (associationType == 'Customer' || customer.type == associationType) {
                <mat-option [value]="customer">
                  <span>{{customer.name}}</span></mat-option>
                }
              }
            </mat-select>
          </mat-form-field>
        }

        <mat-form-field appearance="outline">
          <mat-label translate="">Link to application</mat-label>
          <mat-chip-grid #applicationChipList="">
            <!-- 1. Remove [selectable] and [removable] -->
            @for (application of applications; track application) {
              <mat-chip-row (removed)="removeApplication(application)">
                {{application.name}} - {{application.mortgage?.lender?.name}}
                <!-- 2. Wrap the icon in a button with matChipRemove -->
                <!-- 3. Move the *ngIf to the button -->
                @if (removable) {
                  <button matChipRemove="" [attr.aria-label]="'remove ' + application.name">
                    <mat-icon>cancel</mat-icon>
                  </button>
                }
              </mat-chip-row>
            }

            <input #applicationInput="" [formControl]="applicationFormControl" [matAutocomplete]="applicationAutoComplete" [matChipInputFor]="applicationChipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes" autocomplete="off">
          </mat-chip-grid>
          <mat-autocomplete #applicationAutoComplete="matAutocomplete" (optionSelected)="selectedApplication($event)">
            @for (application of applicationsFiltered | async; track application) {
              <mat-option [value]="application">
                {{application.name}} - {{application.mortgage?.lender?.name}}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>


        @if (associationType == 'Building') {
          <mat-form-field appearance="outline">
            <mat-label translate="">Link to building</mat-label>
            <mat-chip-grid #buildingChipList="">
              <!-- 1. Removed [selectable] and [removable] properties -->
              @for (building of buildings; track building) {
                <mat-chip-row (removed)="removeBuilding(building)">
                  {{building.address.addressLine1}}, {{building.address.city}}
                  <!-- 2. Wrap mat-icon in a <button> with the matChipRemove directive -->
                  <!-- 3. Move the *ngIf check to this button -->
                  @if (removable) {
                    <button matChipRemove="" [attr.aria-label]="'remove ' + building.address.addressLine1">
                      <mat-icon>cancel</mat-icon>
                    </button>
                  }
                </mat-chip-row>
              }
              <input #buildingInput="" [formControl]="buildingFormControl" [matAutocomplete]="buildingAutoComplete" [matChipInputFor]="buildingChipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes" autocomplete="off">
            </mat-chip-grid>
            <mat-autocomplete #buildingAutoComplete="matAutocomplete" (optionSelected)="selectedBuilding($event)">
              @for (building of buildingsFiltered | async; track building) {
                <mat-option [value]="building">
                  {{building.address.addressLine1}}, {{building.address.city}}
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        }

        @if (associationType == 'Mortgage') {
          <mat-form-field appearance="outline">
            <mat-label translate="">Link to mortgage</mat-label>
            <mat-chip-grid #mortgageChipList="">
              <!-- 1. Removed [selectable] and [removable] properties -->
              @for (mortgage of mortgages; track mortgage) {
                <mat-chip-row (removed)="removeMortgage(mortgage)">
                  {{(mortgage.number || "...") + " - " + mortgage.lender?.name}}
                  <!-- 2. Wrap mat-icon in a <button> with the matChipRemove directive -->
                  <!-- 3. Move the *ngIf check to the button -->
                  @if (removable) {
                    <button matChipRemove="" [attr.aria-label]="'remove ' + mortgage.number">
                      <mat-icon>cancel</mat-icon>
                    </button>
                  }
                </mat-chip-row>
              }
              <input #mortgageInput="" [formControl]="mortgageFormControl" [matAutocomplete]="mortgageAutoComplete" [matChipInputFor]="mortgageChipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes" autocomplete="off">
            </mat-chip-grid>
            <mat-autocomplete #mortgageAutoComplete="matAutocomplete" (optionSelected)="selectedMortgage($event)">
              @for (mortgage of mortgagesFiltered | async; track mortgage) {
                <mat-option [value]="mortgage">
                  {{(mortgage.number || "...") + " - " + mortgage.lender?.name}}
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        }

        <mat-form-field appearance="outline">
          <mat-label translate="">Name</mat-label>
          <input formControlName="description" matInput="" type="text" autocomplete="off">
        </mat-form-field>

        @if (documentFormGroup.get('documentType')?.value != null) {
          @if (documentFormGroup.get('documentType')?.value.hasIssueDate) {
            <mat-form-field appearance="outline">
              <mat-label translate="">Issued</mat-label>
              <input matInput="" [matDatepicker]="issuedPicker" formControlName="issued" autocomplete="off">
              <mat-datepicker-toggle matSuffix="" [for]="issuedPicker"></mat-datepicker-toggle>
              <mat-datepicker #issuedPicker=""></mat-datepicker>
            </mat-form-field>
          }
          @if (documentFormGroup.get('documentType')?.value.hasExpirationDate) {
            <mat-form-field appearance="outline">
              <mat-label translate="">Expires</mat-label>
              <input matInput="" [matDatepicker]="expiresPicker" formControlName="expires" autocomplete="off">
              <mat-datepicker-toggle matSuffix="" [for]="expiresPicker"></mat-datepicker-toggle>
              <mat-datepicker #expiresPicker=""></mat-datepicker>
            </mat-form-field>
          }
          @if (documentFormGroup.get('documentType')?.value.hasYear) {
            <mat-form-field appearance="outline">
              <mat-label translate="">Year</mat-label>
              <input matInput="" digitsOnly="" formControlName="year" autocomplete="off">
            </mat-form-field>
          }
        }
        <!-- <mat-checkbox color="primary">
        <span translate>Document has been checked and verified</span>
      </mat-checkbox> -->

    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="flex flex-row justify-start items-center gap-[1rem]">
    <unite-loading-button [text]="'Save' | translate" [loading]="loadingSave" (buttonClick)="save()">
    </unite-loading-button>
    <button type="button" mat-button="" color="warn" (click)="remove()">
      <span translate="">
        Delete
      </span>
    </button>
    <button type="button" mat-button="" mat-dialog-close="">
      <span translate="">
        Cancel
      </span>
    </button>
  </mat-dialog-actions>
</form>
